import restClient from "../restClient";

export const getPaymentCredentialMine = async () => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get("payment-credentials/mine", config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updatePaymentCredentialMine = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(
      "payment-credentials/mine",
      { data },
      config
    );
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
